import CustomerBilledHtml from './customer.billed.html';

export function CustomerBilledDirective () {
  return {
    controller: 'CustomerBilledCtrl',
    restrict: 'E',
    templateUrl: CustomerBilledHtml,
    scope: {
      customer: '=',
      customers: '='
    }
  }
}
